import React from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'material-ui/AutoComplete';
import AutoCompleteTooltip from './AutoCompleteTooltip';
import FieldTitle from 'components/aor/FieldTitle';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

class AutoCompleteField extends React.Component {
    handleNewRequest = (chosenRequest) => {
        const { choices, input, optionValue, onSelectOption } = this.props;

        const choice = choices.find((choice) => {
            return choice[optionValue] == chosenRequest.value;
        }) || {};

        const value = choice[optionValue] || null;

        if (utils.isFunction(onSelectOption)) {
            return onSelectOption(choice);
        }

        return input.onChange(value);
    }

    getSuggestion(choice) {
        const { formatSuggestion, optionText } = this.props;

        if (formatSuggestion) {
            return formatSuggestion(choice);
        }

        return (typeof optionText === 'function') ? optionText(choice) : choice[optionText];
    }

    onBlur = (event) => {
        const { input } = this.props;

        /**
         * We only want to trigger blur this selector when the input value has changed to an empty string.
         * In all the other cases, we want keep the typed data in the input field.
         */
        if (event.target.value === '') {
            input.onBlur(event.target.value);
        }
    }

    render() {
        const {
            animated,
            choices,
            filter,
            floatingLabelFixed,
            fullWidth,
            input: {
                name,
                value,
            },
            label,
            loading,
            meta: {
                touched,
                error,
            },
            translate,
            optionValue,
        } = this.props;

        const selectedSource = utils.find(choices, (choice) => {
            return choice[optionValue] === value;
        });

        const dataSource = utils.map(choices, (choice) => {
            return {
                value: choice[optionValue],
                text: this.getSuggestion(choice),
            };
        });

        return (
            <div>
                <AutoComplete
                    animated={ animated }
                    dataSource={ dataSource }
                    errorText={ touched && error }
                    filter={ filter }
                    fullWidth={ fullWidth }
                    floatingLabelFixed={ floatingLabelFixed }
                    floatingLabelText={ label ? <FieldTitle
                        label={ label }
                        source={ 'source' }
                        resource={ 'resource' }
                    /> : '' }
                    id={ name }
                    onBlur={ this.onBlur }
                    onNewRequest={ this.handleNewRequest }
                    onUpdateInput={ (searchText, dataSource, params) => {
                        const {
                            onInputUpdate,
                        } = this.props;

                        if (utils.isFunction(onInputUpdate)) {
                            this.props.input.onChange(dataSource.value, dataSource);
                            return onInputUpdate(searchText, dataSource, params);
                        }

                        return this.handleNewRequest(null, -1);
                    } }
                    hintText={ translate('components.autocomplete.hinttext') }
                    menuStyle={ {
                        maxHeight: '500px',
                        width: '100%',
                        overflowY: 'auto',
                        touchAction: 'none',
                    } }
                    openOnFocus={ true }
                    searchText={ selectedSource && this.getSuggestion(selectedSource) }
                />

                { (this.props.error || loading) &&
                    <AutoCompleteTooltip error={ this.props.error } loading={ loading } />
                }
            </div>
        );
    }
}

AutoCompleteField.defaultProps = {
    animated: true,
    choices: [],
    filter: AutoComplete.fuzzyFilter,
    floatingLabelFixed: true,
    fullWidth: false,
    optionText: 'name',
    optionValue: 'id',
};

AutoCompleteField.propTypes = {
    animated: PropTypes.bool,
    choices: PropTypes.arrayOf(PropTypes.object),
    error: PropTypes.string,
    filter: PropTypes.func,
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
    formatSuggestion: PropTypes.func,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        onDrop: PropTypes.func,
        value: PropTypes.value,
    }).isRequired,
    label: PropTypes.string,
    loading: PropTypes.bool,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    onInputUpdate: PropTypes.func,
    onSelectOption: PropTypes.func,
    optionText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    optionValue: PropTypes.string,
    translate: PropTypes.func,
};

export default translate(AutoCompleteField);



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/autocomplete/AutoCompleteField.js